import React from 'react';
import ReportSnapshotProvider from 'shared/providers/ReportSnapshotProvider';
import { ReportsTable } from '../ReportGroup';
import SnapshotBody from './SnapshotBody';

interface Props {
  report: ReportsTable;
  onClose: () => void;
}

/**
 * Impact Snapshot modal — the LIGHT / SUPER_LIGHT report editor. Reuses
 * the Program Questions UI (sidebar + question pane + review screen +
 * wizard footer) by mounting the shared ProgramContext through
 * `ReportSnapshotProvider`, which sources questions from
 * `allNpoReportQuestions` (filtered by reportingType) and persists via
 * newNpoAnswer / updateNpoAnswer.
 */
const ImpactSnapshotModal: React.FC<Props> = ({ report, onClose }) => (
  <ReportSnapshotProvider
    reportId={report.dbId}
    programId={report.program?.Id ?? null}
    programName={report.program?.name || report.name}
    reportStage={report.stage}
    reportStatus={report.status}
  >
    <SnapshotBody onClose={onClose} report={report} />
  </ReportSnapshotProvider>
);

export default ImpactSnapshotModal;
